import template from './scheduler.html';
import controller from './scheduler.controller';
import './scheduler.scss';

let schedulerComponent = {
  restrict: 'E',
  bindings: {
    day: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default schedulerComponent;



// WEBPACK FOOTER //
// ./client/app/common/scheduler/scheduler.component.js